import { get, mergeArrays } from ".";
import { PCG7 } from "../config/constants";
import router from "@/router";
import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";
import * as ACTIONS from "../config/constants/action-types";

export function setModelDomicilioOption(
  context,
  modelDomicilio,
  tipoDomicilio
) {
  let copiaDomicilio = context.getters.getDomicilio(tipoDomicilio);
  if (copiaDomicilio.preexistente) {
    modelDomicilio.opcion = PCG7.OPCION.MODIFICAR;
  } else {
    modelDomicilio.opcion = PCG7.OPCION.ALTA;
  }

  if (modelDomicilio.rehacer) {
    modelDomicilio.opcion = PCG7.OPCION.ALTA;
  }
}

export async function processHandleOkStatus(
  context,
  modelDomicilio,
  tipoDomicilio,
  response,
  errores,
  nextStep
) {
  modelDomicilio = mergeArrays(modelDomicilio, response.respuesta);

  if (errores.length === 0) {
    return processValidDomicilio(context, modelDomicilio, response, nextStep);
  }

  for (const e of errores) {
    if (
      await processHandleKnownErrors(
        context,
        modelDomicilio,
        tipoDomicilio,
        response,
        e,
        nextStep
      )
    ) {
      return;
    }
  }
  context.dispatch(ACTIONS.DO_PROCESAR_DOMICILIO_ERROR, errores);
}

export async function processValidDomicilio(
  context,
  modelDomicilio,
  response,
  nextStep
) {
  Vue.$log.info("El impacto del domicilio del cliente devolvio: ", response);

  if (modelDomicilio.tDomic === PCG7.TDOMIC.PARTICULAR) {
    const { coorY: latitud, coorX: longitud } = response.respuesta;
    await context.dispatch(ACTIONS.DO_FETCH_SUCURSALES, { latitud, longitud });
  }

  modelDomicilio.validarPreexistente = true;
  context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);
  context.commit(MUTATIONS.ON_VALIDANDO_DOMICILIO, false);

  if (nextStep) {
    router.push(nextStep);
  }
}

export async function processHandleKnownErrors(
  context,
  modelDomicilio,
  tipoDomicilio,
  response,
  error,
  nextStep
) {
  const errorCode = get(error, "codigo", "");

  if (["CLE0023", "CLE0920", "CLE0919"].includes(errorCode)) {
    await processValidDomicilio(context, modelDomicilio, response, nextStep);
    return true;
  }

  if (["CLE0235", "CLE0236"].includes(errorCode) && !modelDomicilio.rehacer) {
    modelDomicilio.rehacer = true;
    await context.dispatch(ACTIONS.DO_PROCESAR_DOMICILIO, {
      modelDomicilio,
      nextStep,
      tipoDomicilio
    });
    return true;
  }

  if (
    ["CLE0919", "CLE0884"].includes(errorCode) &&
    isCoordinatesValid(modelDomicilio)
  ) {
    modelDomicilio.inusual = true;
    context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);
    return true;
  }

  return false;
}

export function isCoordinatesValid(modelDomicilio) {
  return (
    modelDomicilio.coorX &&
    modelDomicilio.coorY &&
    modelDomicilio.coorX !== "00.000000" &&
    modelDomicilio.coorY !== "00.000000"
  );
}

export function processHandleErrorStatus(context, modelDomicilio, response) {
  if (
    response.respuesta.includes("CLE0884") &&
    isCoordinatesValid(modelDomicilio)
  ) {
    modelDomicilio.inusual = true;
    context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);
    return;
  }
  context.dispatch(
    ACTIONS.DO_PROCESAR_DOMICILIO_ERROR,
    "no se pudo procesar domicilio"
  );
}

export function setRehacerOption(modelDomicilio) {
  if (modelDomicilio.rehacer) {
    modelDomicilio.opcion = PCG7.OPCION.ALTA;
    modelDomicilio.tDomic = PCG7.TDOMIC.CORRESPONDENCIA;
  }
}

export async function guardarHandleOkStatus(
  context,
  modelDomicilio,
  tipoDomicilio,
  response,
  errores,
  nextStep
) {
  modelDomicilio = mergeArrays(modelDomicilio, response.respuesta);

  if (errores.length === 0) {
    return guardarValidDomicilio(context, modelDomicilio, response, nextStep);
  }

  for (const e of errores) {
    if (
      await guardarHandleKnownErrors(
        context,
        modelDomicilio,
        tipoDomicilio,
        response,
        e,
        nextStep
      )
    ) {
      return;
    }
  }
  context.dispatch(ACTIONS.DO_GRABAR_DOMICILIO_ERROR, errores);
}

export async function guardarValidDomicilio(
  context,
  modelDomicilio,
  response,
  nextStep
) {
  Vue.$log.info("El impacto del domicilio del cliente devolvio: ", response);

  modelDomicilio.inusual = false;
  modelDomicilio.validarPreexistente = true;
  context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);
  context.commit(MUTATIONS.ON_VALIDANDO_DOMICILIO, false);

  if (nextStep) {
    router.push(nextStep);
  }
}

export async function guardarHandleKnownErrors(
  context,
  modelDomicilio,
  tipoDomicilio,
  response,
  error,
  nextStep
) {
  const errorCode = get(error, "codigo", "");

  if (["CLE0023", "CLE0920", "CLE0919"].includes(errorCode)) {
    if (modelDomicilio.tDomic === PCG7.TDOMIC.PARTICULAR) {
      const { coorY: latitud, coorX: longitud } = response.respuesta;
      await context.dispatch(ACTIONS.DO_FETCH_SUCURSALES, {
        latitud,
        longitud
      });
    }

    modelDomicilio.inusual = false;
    modelDomicilio.validarPreexistente = true;
    context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);
    context.commit(MUTATIONS.ON_VALIDANDO_DOMICILIO, false);

    if (errorCode === "CLE0919") {
      return true;
    }

    if (nextStep) {
      router.push(nextStep);
    }

    return true;
  }

  if (["CLE0235", "CLE0236"].includes(errorCode) && !modelDomicilio.rehacer) {
    modelDomicilio.rehacer = true;
    await context.dispatch(ACTIONS.DO_GRABAR_DOMICILIO, {
      modelDomicilio,
      nextStep,
      tipoDomicilio
    });
    return true;
  }

  if (errorCode.includes("CLA1691")) {
    modelDomicilio.inusual = true;
    context.commit(MUTATIONS.ON_DOMICILIO, modelDomicilio);
    return true;
  }

  return false;
}
